import React, { Component, Fragment } from 'react';
import Anchor from '../../../../../components/link/Anchor';
import Button from '../../../../../components/Button';
import BaseForm from '../../../../../components/form/BaseForm';
import TableTransfer from '../../../../../components/input/TableTransfer';
import Panel from '../../../../../components/outline/Panel';
import ExcelUploadForm from '../../../../../components/form/ExcelUploadForm';
import { TAG_UPLOAD_TEMPLATE_XLSX_URL } from '../../../../../constants/service/common/staticFileUrlConstants';
import { comparePrePropsAndNextProps, setNumberWithComma } from '../../../../../lib/common';
import { columns } from './columns';
import './TagGroupEditItems.scss';

class TagRelatedItemForm extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps, nextState) => {
    return comparePrePropsAndNextProps([
      [nextProps, this.props],
      [nextState, this.state],
    ]);
  };

  render() {
    const {
      tagGroupItem,
      getTagGroupItemList,
      selectTagGroupItemList,
      getRelatedTagList,
      getTagGroupAllListExcelDownload,
      getTagGroupSelectedListExcelDownload,
      setTagGroupExcelUpload,
    } = this.props;
    const { itemList, selectedItemList } = tagGroupItem;

    return (
      <Panel className="tag-group-edit-items">
        <div className="panel-header">
          <div className="title">태그 그룹에 연결된 아이템(태그)</div>
        </div>

        <div className="panel-body">
          <BaseForm
            label="연결된 태그"
            content={
              <Fragment>
                <span className="number-related-items">{setNumberWithComma(selectedItemList.list.length, '개')}</span>
              </Fragment>
            }
          />

          <TableTransfer
            dataSource={itemList.list}
            operations={['연결', '해제']}
            leftTitle={'태그 리스트'}
            rightTitle={`연결된 태그 리스트`}
            leftTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  getRelatedTagList,
                  isFilter: true,
                }),
              headInfo: (
                <div className="tag-related-item-head">
                  <div className="excel-button-list">
                    <Button
                      isRadius
                      color="light"
                      text="엑셀 다운로드"
                      onClick={() => getTagGroupAllListExcelDownload()}
                    />
                  </div>
                </div>
              ),
              rowClassName: (record) => (record.uncheckable ? 'uncheckable' : null),
              getList: (option) =>
                getTagGroupItemList({
                  ...option,
                }),
              pagination: itemList.pagination,
              sortOption: itemList.sortOption,
              filterOption: itemList.filterOption,
            }}
            rightTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  getRelatedTagList,
                }),
              headInfo: (
                <div className="selected-widget-item-head">
                  <div className="selected-widget-item-count">
                    선택된 아이템 개수 <span>{selectedItemList.list.length}</span>
                  </div>

                  <div className="excel-button-list">
                    <Anchor
                      text="태그 업로드 템플릿"
                      isUnderLine
                      color="primary"
                      href={TAG_UPLOAD_TEMPLATE_XLSX_URL}
                      target="_blank"
                    />

                    <ExcelUploadForm onChange={(file) => setTagGroupExcelUpload(file)} btnText="태그 엑셀 업로드" />

                    <Button
                      isRadius
                      color="light"
                      text="엑셀 다운로드"
                      onClick={() => getTagGroupSelectedListExcelDownload()}
                    />
                  </div>
                </div>
              ),
              list: selectedItemList.list,
            }}
            onChange={(action, moveIdList) => selectTagGroupItemList(action, moveIdList)}
          />
        </div>
      </Panel>
    );
  }
}

export default TagRelatedItemForm;
